// extracted by mini-css-extract-plugin
module.exports = {"time":"RightPane-time-aad3"};